module.exports = __webpack_public_path__ + "img/thumbnail_Raccoon_j_normal.62ac5caf.png";